import { useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { isNumber } from '@app/typeGuards'
import { buildToDestination, mergeSharedSearchParamKeysWithDefault } from '@app/utils/navigation'

import type { NavigateFunction, To } from 'react-router-dom'
import type { NavigateOptions } from 'react-router/dist/lib/context'
import type { UseExtendedNavigateParams } from './types'

export const useExtendedNavigate = ({
  sharedSearchParamKeys: outerSharedSearchParamKeys
}: UseExtendedNavigateParams = {}): NavigateFunction => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const sharedSearchParams = useMemo(
    () => mergeSharedSearchParamKeysWithDefault(outerSharedSearchParamKeys),
    [outerSharedSearchParamKeys]
  )

  return (to: To | number, options?: NavigateOptions): void => {
    if (isNumber(to)) {
      navigate(to)
      return
    }

    const builtTo = buildToDestination(to, searchParams, sharedSearchParams)

    navigate(builtTo, options)
  }
}
